import { motion } from "framer-motion";
import {
  TrendingUp,
  ShieldCheck,
  Banknote,
  Briefcase,
  LineChart,
  Globe2,
  ArrowUpRight,
} from "lucide-react";
import { SERVICES } from "@/lib/brand";

const ICONS = { TrendingUp, ShieldCheck, Banknote, Briefcase, LineChart, Globe2 };

export default function ServicesSection() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid lg:grid-cols-12 gap-8 mb-14 items-end">
          <div className="lg:col-span-7">
            <span className="inline-flex items-center gap-2 text-sm font-medium text-[#00A65A]">
              <span className="w-6 h-px bg-[#00A65A]" />
              What we offer
            </span>
            <h2 className="mt-3 font-display text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight text-[#0B1B3D] leading-[1.04]">
              Every instrument, <span className="italic font-light text-[#00A65A]">curated</span> for you.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-base md:text-lg text-[#0B1B3D]/70 leading-relaxed">
              From traditional fixed deposits to alternative investment funds — we research,
              recommend and review every product against your personal financial blueprint.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <motion.div
                key={s.title}
                data-testid={`service-card-${s.title.replace(/\s/g, '-').toLowerCase()}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.06 }}
                className="group relative bg-white border border-[#0B1B3D]/10 rounded-3xl p-7 md:p-8 hover:border-[#00A65A]/40 transition-all duration-500 hover:shadow-2xl hover:-translate-y-1"
              >
                <div className="flex items-center justify-between mb-7">
                  <div className="w-12 h-12 rounded-2xl bg-[#00A65A]/10 flex items-center justify-center group-hover:bg-[#00A65A] transition-colors">
                    <Icon className="w-5 h-5 text-[#00A65A] group-hover:text-white transition-colors" />
                  </div>
                  <ArrowUpRight className="w-4 h-4 text-[#0B1B3D]/30 group-hover:text-[#00A65A] group-hover:-translate-y-1 group-hover:translate-x-1 transition-all" />
                </div>
                <h3 className="font-display text-2xl md:text-3xl text-[#0B1B3D] leading-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm md:text-base text-[#0B1B3D]/65 leading-relaxed">
                  {s.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
